/**
 * The one place that knows how to reach Google Analytics from the browser.
 *
 * Every reporter (`home-analytics`, `pricing-analytics`, `share-analytics`,
 * `navigation-analytics`, `tools-analytics`) had its own byte-identical copy of
 * this guard, so a change to the SSR check — or to consent gating — would have
 * had to land in five files. It is a no-op during SSR / build-time prerender
 * and whenever analytics is not configured.
 */
export function emitGaEvent(event: string, params: object): void {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", event, params);
  }
}
